import { h } from 'preact';
import React, { Component } from 'react';
import Purposes from './Purposes/Purposes';
import Features from './Features/Features';
import Vendors from './Vendors/Vendors';
import { PrivacyManagerTCFv2Settings } from './PrivacyManagerTCFv2Settings';
import './PrivacyManagerTCFv2.css';
import { makeText } from '../../util';

export class PrivacyManagerTCFv2 extends Component {
  state = {
    tab: this.props.pmTab ? this.props.pmTab || 'purposes' : this.props.message.defaultTab || 'purposes',
    loading: true
  }
  changeTab = (tab) => this.setState({ tab })
  render() {
    const Settings = new PrivacyManagerTCFv2Settings(this.props.component.settings);
    const { language } = this.props;
    let { tab } = this.state;

    const data = this.props.pmData || {};

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = { ...this.props.dev.hover };
      selected = this.props.dev.current === path;
    }

    const sectionStyles = {};
    sectionStyles.minHeight = Settings.minHeight.type === 'auto' ? 'auto' : Settings.minHeight.value + Settings.minHeight.type;
    sectionStyles.maxHeight = Settings.maxHeight.type === 'auto' ? 'auto' : Settings.maxHeight.value + Settings.maxHeight.type;

    const className = 'message-component message-stacks privacy-manager-tcfv2 no-children' + this.props.className;

    const purposesText = makeText(Boolean(this.props.dev), Settings, 'purposesText', language);
    const featuresText = makeText(Boolean(this.props.dev), Settings, 'featuresText', language);
    const vendorsText = makeText(Boolean(this.props.dev), Settings, 'vendorsText', language);

    const vendorList = data.vendors || [];
    if (Settings.alphabetizeVendors) {
      vendorList.sort((a, b) =>{
        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
        return 0;
      });
    }

    const useStacks = this.props.message.useStacks;
    const consentOnlyStacks = this.props.message.consentOnlyStacks;
    const usePurModel = this.props.message.usePurModel;
    return (
      <div className={selected ? className + ' on-active' : className} path={path} {...devActions}>

        <div className="pm-tabs">
          {data.categories && data.categories.length > 0 && (
            <div
              tabindex="0"
              className={tab.includes('purposes') ? 'pm-tab active' : 'pm-tab'}
              onClick={() => this.changeTab('purposes')}
              onKeyDown={(e) => e.keyCode === 13 && this.changeTab('purposes')}
              title={purposesText}
              aria-label={purposesText}
            >
              {purposesText}
            </div>
          )}
          {data.features && data.features.length > 0 && (
            <div
              tabindex="0"
              className={tab === 'features' ? 'pm-tab active' : 'pm-tab'}
              onClick={() => this.changeTab('features')}
              onKeyDown={(e) => e.keyCode === 13 && this.changeTab('features')}
              title={featuresText}
              aria-label={featuresText}
            >
              {featuresText}
            </div>
          )}
          {data.vendors && data.vendors.length > 0 && (
            <div
              tabindex="0"
              className={tab.includes('vendors') ? 'pm-tab active' : 'pm-tab'}
              onClick={() => this.changeTab('vendors')}
              onKeyDown={(e) => e.keyCode === 13 && this.changeTab('vendors')}
              title={vendorsText}
              aria-label={vendorsText}
            >
              {vendorsText}
            </div>
          )}
        </div>

        {tab.includes('purposes') && data.categories !== undefined && (
          <div className="pm-section" style={sectionStyles}>
            <Purposes
              dev={this.props.dev}
              stacks={data.stacks || []}
              useStacks={useStacks}
              consentOnlyStacks={consentOnlyStacks}
              purposes={data.categories || []}
              specialPurposes={data.specialPurposes || []}
              language={this.props.language}
              settings={Settings}
              togglePurposeOrFeature={this.props.togglePurposeOrFeature}
              toggleStack={this.props.toggleStack}
              startWithLiToggled={tab === 'purposes-li'}
              usePurModel={usePurModel}
            />
          </div>
        )}

        { tab === 'features' && data.features !== undefined && (
          <div className="pm-section" style={sectionStyles}>
            <Features dev={this.props.dev} features={data.features || []} specialFeatures={data.specialFeatures || []} language={this.props.language} settings={Settings} togglePurposeOrFeature={this.props.togglePurposeOrFeature} />
          </div>
        )}

        {tab.includes('vendors') && data.vendors !== undefined && (
          <div className="pm-section" style={sectionStyles}>
            <Vendors
              dev={this.props.dev}
              vendors={vendorList}
              settings={Settings}
              language={this.props.language}
              toggleVendor={this.props.toggleVendor}
              startWithLiToggled={tab === 'vendors-li'}
              usePurModel={usePurModel}
            />
          </div>
        )}

      </div>
    );
  }
}
